var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',_vm._g(_vm._b({attrs:{"type":_vm.btnType}},'Button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_c('CustomIcon',{staticStyle:{"vertical-align":"-1px"},attrs:{"type":_vm.type,"size":"16"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }